enum AssociatedProgramStatus {
  CONFIGURATION = "CONFIGURATION",
  ACTIVITY_PROFILE = "ACTIVITY_PROFILE",
  SELECTION = "SELECTION",
  SHORTLIST = "SHORTLIST",
  ACTIVITY_MATCHING = "ACTIVITY_MATCHING",
  ACCEPT_ACTIVITY_SCHEDULE = "ACCEPT_ACTIVITY_SCHEDULE",
  INVITES_SENT = "INVITES_SENT",
  IN_PROGRESS = "IN_PROGRESS",
  RECONCILIATION = "RECONCILIATION",
  FEEDBACK = "FEEDBACK",
  COMPLETED = "COMPLETED"
}

// Do not change order of this enum
export enum AssociatedProgramStatusByValue {
  CONFIGURATION = 0,
  ACTIVITY_PROFILE,
  SELECTION,
  SHORTLIST,
  ACTIVITY_MATCHING,
  ACCEPT_ACTIVITY_SCHEDULE,
  INVITES_SENT,
  IN_PROGRESS,
  RECONCILIATION,
  FEEDBACK,
  COMPLETED
}

export function isBetweenActivityProfileAndSelection(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return (
    statusValue >= AssociatedProgramStatusByValue.ACTIVITY_PROFILE &&
    statusValue <= AssociatedProgramStatusByValue.SELECTION
  );
}

export function isBeforeSelection(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue < AssociatedProgramStatusByValue.SELECTION;
}

export function isBeforeShortlist(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue < AssociatedProgramStatusByValue.SHORTLIST;
}

export function isAfterShortlist(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue > AssociatedProgramStatusByValue.SHORTLIST;
}

export function isBeforeAcceptActivitySchedule(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue < AssociatedProgramStatusByValue.ACCEPT_ACTIVITY_SCHEDULE;
}

export function isAfterAcceptActivitySchedule(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue > AssociatedProgramStatusByValue.ACCEPT_ACTIVITY_SCHEDULE;
}

export function isAfterInvitesSent(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue > AssociatedProgramStatusByValue.INVITES_SENT;
}

export function isInProgress(status?: AssociatedProgramStatus): boolean {
  return status === AssociatedProgramStatus.IN_PROGRESS;
}

export function isAfterInProgress(status?: AssociatedProgramStatus): boolean {
  if (!status) return false;
  const statusValue = AssociatedProgramStatusByValue[status];
  return statusValue > AssociatedProgramStatusByValue.IN_PROGRESS;
}

export const AssociatedProgramStatusCheck = {
  isBetweenActivityProfileAndSelection,
  isBeforeSelection,
  isBeforeShortlist,
  isAfterShortlist,
  isBeforeAcceptActivitySchedule,
  isAfterAcceptActivitySchedule,
  isAfterInvitesSent,
  isInProgress,
  isAfterInProgress
};

export default AssociatedProgramStatus;
